import { useState } from "react"

import Button from "react-bootstrap/Button"
import Spinner from "react-bootstrap/Spinner"

type SpinnerButtonProps = {
    className?: string,
    disabled: boolean,
    handleFunction: () => Promise<void>,
    size: "sm" | "lg",
    text: string,
    type?: "button" | "submit" | "reset",
    variant: string
}

const SpinnerButton = ({ className, disabled, handleFunction, size, text, type, variant }: SpinnerButtonProps) => {
    const [showSpinner, setShowSpinner] = useState(false)

    const handleClick = async () => {
        setShowSpinner(true)

        try {
            await handleFunction()
        } catch (e) {
            
        }

        setShowSpinner(false)
    }
    
    return (
        <Button
            className={className}
            type={type}
            variant={variant}
            size={size}
            onClick={async () => await handleClick()}
            disabled={disabled}
        >
            {showSpinner
                ? <Spinner size='sm' role='status' />
                : <span>{text}</span>
            }
        </Button>
    )
}

export default SpinnerButton